import React from 'react';
import { Edit, Loader2, CalendarX2 } from 'lucide-react';
import { getTodayLocal } from '../../utils/formatters';
import { StatusPill, Button, Card } from '../ui';

const headers = ['Ações', 'ID', 'Estado', 'Nome do Cliente', 'Data', 'Hora', 'Pessoas', 'Telefone', 'Mensagem'];

const ReservationTable = ({ reservations, onEdit, loading = false }) => {
  const currentDate = getTodayLocal();
  const isPastReservation = (date) => date < currentDate;

  return (
    <Card className="overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead className="bg-surface-2">
            <tr>
              {headers.map((h) => (
                <th
                  key={h}
                  className="px-4 py-3 text-left text-xs font-semibold text-muted uppercase tracking-wider"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {loading ? (
              <tr>
                <td colSpan="9" className="px-4 py-12 text-center text-muted">
                  <span className="inline-flex items-center gap-2">
                    <Loader2 className="h-5 w-5 animate-spin" />
                    A carregar reservas...
                  </span>
                </td>
              </tr>
            ) : reservations.length > 0 ? (
              reservations.map((reservation) => {
                const isPast = isPastReservation(reservation.booking_date);
                return (
                  <tr
                    key={reservation.id}
                    className={isPast ? 'text-muted-2' : 'text-foreground hover:bg-surface-2/60 transition-colors'}
                  >
                    <td className="px-4 py-3 text-sm">
                      <Button size="sm" icon={Edit} onClick={() => onEdit(reservation)}>
                        Editar
                      </Button>
                    </td>
                    <td className="px-4 py-3 text-sm">{reservation.id}</td>
                    <td className="px-4 py-3 text-sm">
                      <StatusPill state={reservation.state} />
                    </td>
                    <td className="px-4 py-3 text-sm font-medium">{reservation.name}</td>
                    <td className="px-4 py-3 text-sm">{reservation.booking_date}</td>
                    <td className="px-4 py-3 text-sm">
                      {reservation.from_time} - {reservation.to_time}
                    </td>
                    <td className="px-4 py-3 text-sm text-center">{reservation.total_guest}</td>
                    <td className="px-4 py-3 text-sm">{reservation.phone}</td>
                    <td className="px-4 py-3 text-sm max-w-xs truncate" title={reservation.message}>
                      {reservation.message || '-'}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" className="px-4 py-12 text-center text-muted">
                  <span className="inline-flex flex-col items-center gap-2">
                    <CalendarX2 className="h-8 w-8 text-muted-2" />
                    Não foram encontradas reservas com os critérios selecionados.
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default ReservationTable;
